<mat-form-field appearance="fill">
  <mat-label>{{ props.label }}</mat-label>

  <input
    [owlDateTime]="dt2"
    matInput
    [id]="id"
    [type]="'text'"
    [readonly]="props.readonly"
    [required]="required"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [tabIndex]="props.tabindex"
    [placeholder]="props.placeholder ?? ''"
  />
  <button mat-icon-button matSuffix [owlDateTimeTrigger]="dt2" type="button">
    <mat-icon>event</mat-icon>
  </button>
  <owl-date-time #dt2 [hour12Timer]="true"></owl-date-time>

  <mat-error>
    <formly-validation-message [field]="field"></formly-validation-message>
  </mat-error>
</mat-form-field>
